import React, { useEffect, useRef, useState } from 'react';

import classNames from 'classnames';

import cls from './index.module.css';

interface TagProps extends React.HTMLProps<HTMLLIElement> {
    tagName: string;
    // tags?: string[];
    classes?: string;
}

export const Tag = ({ tagName, classes }: TagProps) => {
    const [isHovered, setIsHovered] = useState(false);
    const elementRef = useRef(null);

    return (
        <div className={cls.Tag__Wrapper} ref={elementRef}>
            {/* {isHovered && <TagsListBlock tags={tags} isOnRight={isOnRight} />} */}
            <li
                className={classNames(cls.Tag, [classes])}
                onMouseEnter={() => {
                    setIsHovered(true);
                }}
                onMouseLeave={() => {
                    setIsHovered(false);
                }}
            >
                {tagName}
            </li>
        </div>
    );
};
